/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ContainerFindingsRequest {
    getFixupPrototypeFunction() { return ContainerFindingsRequest.fixupPrototype; }

    static newInstance(model: Partial<ContainerFindingsRequest>): ContainerFindingsRequest {
        let obj = Object.assign(new ContainerFindingsRequest(), model);
        ContainerFindingsRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ContainerFindingsRequest>): ContainerFindingsRequest {
        if (!model) return null;
        return ContainerFindingsRequest.newInstance(<ContainerFindingsRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ContainerFindingsRequest) {
        if (!obj) return;

        models.ContainerFindingsRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ContainerFindingsRequest): boolean {
        Object.setPrototypeOf(obj, ContainerFindingsRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.list_context) {
            models.ListContext.fixupPrototype(this.list_context);
        }
        if (this.filters) {
            models.ContainerFindingsBaseFilters.fixupPrototype(this.filters);
        }
        if (this.sort) {
            for (let val of this.sort) {
                models.ContainerFindingsFiltersSortCriteria.fixupPrototype(val);
            }
        }
    }

    /**
     * Optional list context
     */
    list_context: models.ListContext;

    /**
     * Sort criteria
     */
    sort: Array<models.ContainerFindingsFiltersSortCriteria>;

    /**
     * Filters for the request
     */
    filters: models.ContainerFindingsBaseFilters;

}
